/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiPushnotificationsGet } from '../fn/push-notification/api-pushnotifications-get';
import { ApiPushnotificationsGet$Params } from '../fn/push-notification/api-pushnotifications-get';
import { MultipleReturnGetPushNotificationsDto } from '../models/multiple-return-get-push-notifications-dto';

@Injectable({ providedIn: 'root' })
export class PushNotificationService extends BaseService {
    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http);
    }

    /** Path part for operation `apiPushnotificationsGet()` */
    static readonly ApiPushnotificationsGetPath = '/api/pushnotifications';

    /**
     * Get all push notifications.
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     * To access only the response body, use `apiPushnotificationsGet()` instead.
     *
     * This method doesn't expect any request body.
     */
    apiPushnotificationsGet$Response(
        params?: ApiPushnotificationsGet$Params,
        context?: HttpContext,
    ): Observable<StrictHttpResponse<MultipleReturnGetPushNotificationsDto>> {
        return apiPushnotificationsGet(this.http, this.rootUrl, params, context);
    }

    /**
     * Get all push notifications.
     *
     *
     *
     * This method provides access only to the response body.
     * To access the full response (for headers, for example), `apiPushnotificationsGet$Response()` instead.
     *
     * This method doesn't expect any request body.
     */
    apiPushnotificationsGet(
        params?: ApiPushnotificationsGet$Params,
        context?: HttpContext,
    ): Observable<MultipleReturnGetPushNotificationsDto> {
        return this.apiPushnotificationsGet$Response(params, context).pipe(
            map((r: StrictHttpResponse<MultipleReturnGetPushNotificationsDto>): MultipleReturnGetPushNotificationsDto => r.body),
        );
    }
}
